export enum MediaUploaderTabs {
  FromFile = 'From File',
  ByURL = 'By URL',
  Gallery = 'Gallery',
}

export interface AgMediaUploadModel {
  description: string;
  contentType: string;
  file: any;
}

export const FILE_NAME_VALIDATION_GROUP = 'fileNameValidationGroup';
export const DEFAULT_MAX_MEDIA_UPLOAD_SIZE_MB = 20;
export const HTML_EDITOR_MAX_MEDIA_UPLOAD_SIZE_KB = 350;
export const HTML_EDITOR_MAX_MEDIA_UPLOAD_SIZE_MB = HTML_EDITOR_MAX_MEDIA_UPLOAD_SIZE_KB / 1024;
